<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="customer-modal-contacted" :title="`¿Contactaste a ${customer?.name}?`" subtitle="Cambiar estado del cliente a contactado" bodyClass="container-md vstack gap-5">
		<template #body>
			<div class="vstack gap-5">
				<CommonFormInputTextarea v-model="form.observations" title="Observaciones" subtitle="Opcional" placeholder="Ingrese una observacion" />
			</div>
		</template>
		<template #footer>
			<a href="javascript:void(0);" class="link-danger" data-bs-dismiss="offcanvas">No logré contactarme</a>
			<button type="button" class="btn rounded-pill btn-primary" :disabled="submitting" @click="submit">Registrar contacto</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
	import { Modal, Offcanvas } from 'bootstrap';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CustomerRepository from '@/repositories/modules/Customer';

	export default {
		setup(props) {
			const { submitting, catchError } = composableForm();
			const instance = getCurrentInstance();
			const offcanvas = ref(null);
			const customer = ref(null);

			const form = reactive({
				status: 'contacted',
				extras: null,
				observations: null
			});

			const closeOpenOffcanvas = () => {
				if(document.querySelector('.offcanvas.show')) {
					var offcanvasShowed = Offcanvas.getInstance(document.querySelector('.offcanvas.show'));
					offcanvasShowed.hide();
				}

				if(document.querySelector('.modal.show')) {
					var modalShowed = Modal.getInstance(document.querySelector('.modal.show'));
					modalShowed.hide();
				}
			}

			const customerContacted = (dataCustomer = null, dataExtras = null) => {
				closeOpenOffcanvas();
				customer.value = dataCustomer;
				form.extras = dataExtras;
				form.observations = null;
				offcanvas.value.offcanvas.show();
			}

			const submit = async () => {
				submitting.value = true;

				await CustomerRepository.history(customer.value.id, form).then((response) => {
					offcanvas.value.offcanvas.hide();

					if(instance.proxy?.$customerRefresh && typeof instance.proxy.$customerRefresh === 'function')
						instance.proxy.$customerRefresh();
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			onMounted(() => {
				if(instance) instance.appContext.config.globalProperties.$customerContacted = customerContacted;
			});

			return { submitting, customer, offcanvas, submit, form };
		}
	}
</script>